import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import BillToTableContainer from "./BillToTableContainer";
import { OrdersWrapper } from "../../../components/styledComponents";
import BillToFormContainer from "./BillToFormContainer";
import { useSelector, useDispatch } from "react-redux";
import {
  getBillToData,
  getSingleBillToData,
} from "../../../store/actions/maintenanceBillToActions";
import useUnsavedChangesWarning from "../../../components/Alerts/useUnsavedChangesWarning";
import { mapBillToScreenData } from "./components/commonFn";

export default function BillTo({ isOrderScreen, handleBillToData }) {
  const [addNewPickUpDispo, setAddNewPickUpDispo] = useState(false);
  const [editShipperClicked, setEditShipperClicked] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowsCount, setRowsCount] = useState(1);
  const dispatch = useDispatch();
  const [formKey, setFormKey] = useState(0);
  const [reqQuery, setReqQuery] = useState({
    pageData: { page: 1, pageSize: 50 },
    sortData: { field: "name", sort: "asc" },
    searchText: "",
    billToStatus: "A",
  });
  const ordersLocation = useSelector(
    ({ orderReducer }) => orderReducer.ordersLocation,
  );
  const condition = editShipperClicked || addNewPickUpDispo;

  useUnsavedChangesWarning(condition);

  useEffect(() => {
    setSelectedRow("");

    if (typeof ordersLocation?.locationNumber !== "undefined") {
      setIsLoading(true);
      billToTableApiCall();
    }
  }, [ordersLocation]);

  const billToTableApiCall = (pageData, sortData, searchText, billToStatus) => {
    setReqQuery((prevState) => ({
      ...prevState,
      ...(pageData && { pageData }),
      ...(sortData && { sortData }),
      ...(searchText !== undefined && { searchText }),
      ...(billToStatus && { billToStatus }),
    }));

    setIsLoading(true);
    dispatch(
      getBillToData({
        billToStatus: billToStatus ? billToStatus : reqQuery.billToStatus,
        pageData: pageData ? pageData : reqQuery.pageData,
        sortData: sortData ? sortData : reqQuery.sortData,
        search: searchText !== undefined ? searchText : reqQuery.searchText,
      }),
    ).then((res) => {
      if (res?.data) {
        setRows(res?.data);
        setRowsCount(res?.count);
      } else {
      }
      setIsLoading(false);
    });
  };
  useEffect(() => {
    setFormKey((prevKey) => (prevKey === 0 ? 1 : 0)); // Toggle between 0 and 1
  }, [selectedRow, addNewPickUpDispo]);

  useEffect(() => {
    if (isOrderScreen && selectedRow) {
      const fetchDataToSendOrderScreen = async () => {
        const code = selectedRow;
        try {
          const res = await dispatch(
            getSingleBillToData({
              code: code,
            }),
          );
          const mapDataToSendOrderScreen = mapBillToScreenData(
            res?.shipperForm,
          );
          handleBillToData(mapDataToSendOrderScreen);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchDataToSendOrderScreen();
    }
  }, [selectedRow]);
  if (isOrderScreen) {
    // Show only the full-width grid if isOrderScreen is true
    return (
      <OrdersWrapper>
        <Grid container>
          <Grid item xs={12}>
            <div
              style={{
                height: "100%",
                width: "100%",
                padding: "10px",
              }}
            >
              <BillToTableContainer
                setSelectedRow={setSelectedRow}
                setAddNewPickUpDispo={setAddNewPickUpDispo}
                setEditShipperClicked={setEditShipperClicked}
                setRows={setRows}
                rows={rows}
                billToTableApiCall={billToTableApiCall}
                isLoading={isLoading}
                rowsCount={rowsCount}
                setRowsCount={setRowsCount}
                setIsLoading={setIsLoading}
                selectedRow={selectedRow}
                addNewPickUpDispo={addNewPickUpDispo}
                editShipperClicked={editShipperClicked}
                isOrderScreen={isOrderScreen}
              />
            </div>
          </Grid>
        </Grid>
      </OrdersWrapper>
    );
  }

  return (
    <OrdersWrapper style={{ overflowX: "hidden" }}>
      <Grid container>
        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
          <div
            style={{
              height: `calc(100vh - 90px)`,
              width: "100%",
              padding: "10px",
               overflow: "hidden", 
            }}
          >
            <BillToTableContainer
              setSelectedRow={setSelectedRow}
              setAddNewPickUpDispo={setAddNewPickUpDispo}
              setEditShipperClicked={setEditShipperClicked}
              setRows={setRows}
              rows={rows}
              billToTableApiCall={billToTableApiCall}
              isLoading={isLoading}
              rowsCount={rowsCount}
              setRowsCount={setRowsCount}
              setIsLoading={setIsLoading}
              selectedRow={selectedRow}
              addNewPickUpDispo={addNewPickUpDispo}
              editShipperClicked={editShipperClicked}
              isOrderScreen={false}
            />
          </div>
        </Grid>

        <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
          <div
            style={{
              height: `calc(100vh - 90px)`,
              width: "100%",
              padding: !addNewPickUpDispo ? "0px" : "10px",
              overflowX: "hidden", 
              overflowY: "auto",
            }}
          >
            {addNewPickUpDispo || selectedRow ? (
              <BillToFormContainer
                key={formKey}
                formKey={formKey}
                selectedRow={selectedRow}
                setRows={setRows}
                billToTableApiCall={billToTableApiCall}
                addNewPickUpDispo={addNewPickUpDispo}
                setAddNewPickUpDispo={setAddNewPickUpDispo}
                setSelectedRow={setSelectedRow}
                onEditShipper={setEditShipperClicked}
              />
            ) : (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <h3 style={{ fontSize: "22px", color: "#707070" }}>
                  {" "}
                  Open any Bill To
                </h3>
              </div>
            )}
          </div>
        </Grid>
      </Grid>
    </OrdersWrapper>
  );
}
